import { configCategory, configSite } from "@pub/config";

import { CUESection } from "../types/Opensearch";
import { StoryDataSection } from "../types/ServerCustomContext";
import { splitTextENZH } from "./splitTextENZH";

/**
 * Let's build our section path. By default, section unique names coming from
 * CaaS are split using '_' instead of '/'. For example, 'fashion_news-trends'.
 */
export const sectionUniqNameToPath = (uniqueName: string) => {
  return "/" + uniqueName.split("_").join("/");
};

export const mapSection = ({
  name,
  uniqueName,
  parent,
}: CUESection): StoryDataSection => {
  const returnValue = {
    uniqueName,
    name,
    path: sectionUniqNameToPath(uniqueName || ""),
    // Child sections can only appear with parent
    parent:
      !configCategory.hideChildSection && parent
        ? mapSection(parent)
        : undefined,
  };

  if (configSite.splitZHSectionName) {
    const { textEN, textZH } = splitTextENZH(name);
    return {
      ...returnValue,
      name: textEN,
      nameZH: textZH,
    };
  }
  return returnValue;
};

export const extractSectionInfo = (
  sections: StoryDataSection[],
  uniqSectionName: string,
): StoryDataSection | undefined => {
  const sectionInfo = sections.find((s) => s.uniqueName === uniqSectionName);
  if (sectionInfo) {
    return sectionInfo;
  }
  const parents = sections
    .map((section) => section.parent)
    .filter((section): section is StoryDataSection => !!section);
  if (parents.length) {
    return extractSectionInfo(parents, uniqSectionName);
  }
  return;
};
